module.exports = __webpack_public_path__ + "img/pic-paging-service-1.4bafcfc1.jpg";